export default function TeamMemberCreated({ member }) {
	return member.createdAt?.toDate().toLocaleDateString(undefined, {
		year: "numeric",
		month: "long",
		day: "numeric",
	});
}
